
















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class SearchInput extends Vue {
  @Prop({default: 'Button'}) SearchType!: string;
  @Prop({default: '请输入名称'}) placeholder!: string;
  @Prop({default: '#ee0a00'}) buttonBg!: string;
  @Prop() clearInput!: any;
  data = '';
  InputData(e: any) {
    this.$emit('fetchSearch', e.target.value);
  }
  onSubmit(e: any) {
    this.$emit('startSearch');
  }
  @Watch('clearInput')
  onClearInputChanged() {
    this.data = '';
  }
}
